<template>
  <el-carousel v-bind="$props"
               @change="callback"
               :height="mobileDevice ? '7.5rem' : '6.5rem'">
    <!-- <el-carousel-item v-for="(item, index) in images"
                      v-bind:key="index">
      <div class="bg"
           :style="{backgroundImage: `url('${item}')` }"></div>
    </el-carousel-item> -->
    <el-carousel-item v-if="images.length === 1 || !mobileDevice">
      <div class="bg"
           :style="{backgroundImage: `url('${images[0]}')` }"></div>
    </el-carousel-item>
    <el-carousel-item v-if="images.length === 2 && mobileDevice">
      <div class="bg"
           :style="{backgroundImage: `url('${images[1]}')` }"></div>
    </el-carousel-item>
    <slot></slot>
  </el-carousel>
</template>

<script>
import { Carousel } from 'element-ui'

export default {
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      }
    }
  },
  props: {
    ...Carousel.props,
    images: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    callback(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-carousel {
  overflow: hidden;
  /deep/.el-carousel__indicators {
    display: none;
  }
  .bg {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: local;
    width: 100%;
    height: 100%;
  }
  /deep/.el-carousel__arrow {
    background-color: rgba(31, 45, 61, 0);
    height: 76px;
    width: 76px;
    i {
      font-size: 36px;
    }

    &:hover {
      background-color: #069dcc;
    }
  }
}
</style>
